// Portal v2 Slice F — messages API client (2026-08-30).
import { api } from "@/lib/api";

export interface PortalThread {
  id: string;
  subject: string | null;
  projectId: string | null;
  projectName: string | null;
  lastMessageAt: string;
  unreadCount: number;
}

export interface PortalMessage {
  id: string;
  authorSide: "client" | "staff";
  authorName: string | null;
  body: string;
  createdAt: string;
}

export interface PortalThreadDetail {
  id: string;
  subject: string | null;
  projectId: string | null;
  projectName: string | null;
  messages: PortalMessage[];
}

export async function fetchPortalThreads(): Promise<{
  threads: PortalThread[];
}> {
  return api("/portal/messages");
}

export async function fetchPortalThread(
  id: string,
): Promise<PortalThreadDetail> {
  return api(`/portal/messages/${id}`);
}

export async function createPortalThread(args: {
  subject?: string;
  body: string;
}): Promise<{ thread_id: string }> {
  return api("/portal/messages", {
    method: "POST",
    body: JSON.stringify(args),
  });
}

export async function replyPortalThread(
  id: string,
  body: string,
): Promise<{ ok: boolean }> {
  return api(`/portal/messages/${id}/reply`, {
    method: "POST",
    body: JSON.stringify({ body }),
  });
}
